import React, { createContext, useState, useContext, useCallback } from "react";
import DonationPopup from "../pages/DonationPopup";

// Create context
const DonationContext = createContext();

// Hook for easy use
export const useDonation = () => useContext(DonationContext);

// Provider component
export const DonationProvider = ({ children }) => {
  const [showPopup, setShowPopup] = useState(false);

  const openDonation = useCallback(() => setShowPopup(true), []);
  const closeDonation = useCallback(() => setShowPopup(false), []);

  return (
    <DonationContext.Provider value={{ openDonation, closeDonation }}>
      {children}
      <DonationPopup show={showPopup} onClose={closeDonation} />
    </DonationContext.Provider>
  );
};
